import Route from '@ember/routing/route';

export default class HotelWizardsRoute extends Route {}
